import React from 'react';
import CheckCircleOutlineRounded from '@mui/icons-material/CheckCircleOutlineRounded';
import { objectWithFallback } from 'utils/object-utils';
import GeneralChipField from 'shared-fields/GeneralChipField';
import { VideoState } from 'constants/video-state';
import LoopRounded from '@mui/icons-material/LoopRounded';
import EventBusyRounded from '@mui/icons-material/EventBusyRounded';
import HistoryToggleOffRounded from '@mui/icons-material/HistoryToggleOffRounded';

const ICON_MAP = objectWithFallback(
  {
    [VideoState.PUBLISHED]: <CheckCircleOutlineRounded color="success" />,
    [VideoState.PUBLISHING]: <LoopRounded color="warning" />,
    [VideoState.EXPIRED]: <EventBusyRounded color="error" />,
    [VideoState.WAITING_FOR_PUBLISH]: <HistoryToggleOffRounded color="disabled" />,
  },
  null,
);
const COLOR_MAP = objectWithFallback(
  {
    [VideoState.PUBLISHED]: 'success',
    // [VideoState.PUBLISHING]: 'info',
    // [VideoState.EXPIRED]: 'error',
    [VideoState.WAITING_FOR_PUBLISH]: 'warning',
  },
  'default',
);
const VARIANT_MAP = objectWithFallback(
  {
    [VideoState.PUBLISHED]: 'default',
  },
  'outlined',
);

export function StateField(props) {
  return (
    <GeneralChipField
      iconMap={ICON_MAP}
      colorMap={COLOR_MAP}
      variantMap={VARIANT_MAP}
      {...props}
      source="state"
    />
  );
}

StateField.defaultProps = {
  label: 'State',
};
